<template>
  <div id="canvas">
    <div class="download-search">
      <div class="row">
        <div class="col-md-4">
          <nav aria-label="breadcrumb">
            <ol class="report-bread breadcrumb">
              <li class="breadcrumb-item"><a href="#">Report</a></li>
              <li class="breadcrumb-item active" aria-current="page">
                Source Summary Report
              </li>
            </ol>
          </nav>
        </div>
        <div class="col-md-8">
          <div class="download-links">
            <ul class="d-flex align-items-center justify-content-end">
              <!---start--->
              <li class="timeline">
                <button
                  type="button"
                  v-on:click="getSourceSummaryReprot('today')"
                  v-bind:class="filters_.duration == 'today' ? 'current' : ''"
                >
                  <span class="today">Today</span>
                </button>
              </li>
              <li class="timeline">
                <button
                  type="button"
                  v-bind:class="filters_.duration == 'month' ? 'current' : ''"
                  v-on:click="getSourceSummaryReprot('month')"
                >
                  <span class="today">This Month</span>
                </button>
              </li>
              <li class="timeline datepicker-timeline">
                <button
                  type="button"
                  class="calender"
                  v-bind:class="filters_.duration == 'custom' ? 'current' : ''"
                >
                  <date-range-picker
                    :opens="'left'"
                    :ranges="false"
                    :locale-data="{ format: 'yyyy-mm-dd' }"
                    v-model="filters_.customDate"
                    @update="getSourceSummaryReprot('custom')"
                  ></date-range-picker
                  ><span class="calender">Custom Date</span>
                </button>
              </li>
              <li class="timeline">
                <button
                  @click="exportSalesRapData(filters_.duration)"
                  :disabled="btnLoader"
                  type="button"
                >
                  <span v-if="btnLoader"
                    ><span class="spinner-grow spinner-grow-sm"></span>
                    Loading...</span
                  >
                  <span v-if="!btnLoader"> Export CSV</span>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- ounter-grid -->
    <div class="">
      <div class="dataTables_wrapper no-footer">
        <div class="graph-area">
          <div class="grap-title">
            <div class="title-grap">
              <h4>Source Summary Report</h4>
            </div>
          </div>
          <div style="width: 200px; margin: 0px auto">
            <!-- <atom-spinner
              v-if="loading"
              :animation-duration="1000"
              :size="60"
              :color="'#3151A1'"
            /> -->
            <img v-if="loading" style="display: block;margin-left: auto;margin-right: auto;width: 100px;" src="../../assets/img/Spinner.gif" />
          </div>
          <div class="dataTables_wrapper no-footer" v-if="!loading">
            <table
              id="sourceSummaryReport"
              class="customReportsTable display dataTable no-footer"
            >
              <thead>
                <tr>
                  <th class="text-center">Lead Source</th>
                  <th class="text-center">Leads</th>
                  <th class="text-center">Duplicate Leads</th>
                  <th class="text-center">Appts Set</th>
                  <th class="text-center">Appt Show</th>
                  <th class="text-center">Appt Shown %</th>
                  <th class="text-center">Sold</th>
                  <th class="text-center">Sold %</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="data in orderbysource" :key="data.key">
                  <td class="text-center">{{ data.source }}</td>
                  <td class="text-center">{{ data.total_leads }}</td>
                  <td class="text-center">{{ data.duplicate_leads }}</td>
                  <td class="text-center">{{ data.appointments_set }}</td>
                  <td class="text-center">{{ data.appointments_shown }}</td>
                  <td class="text-center">
                    {{ data.appointments_percentage }}
                  </td>
                  <td class="text-center">{{ data.sold_leads }}</td>
                  <td class="text-center">{{ data.sold_leads_percentage }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- graph-area -->
</template>
<script>
import axios from "axios";
// import VueApexCharts from "vue-apexcharts";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
// import axios from "axios";
// import moment from "moment";
// import jsPDF from "jspdf";
// import * as htmlToImage from "html-to-image";
// import $ from "jquery";
import moment from "moment";
import $ from "jquery";
import { orderBy } from "lodash";
// // import jsPDF from "jspdf";
// // import html2canvas from "html2canvas";
// import { AtomSpinner } from "epic-spinners";

export default {
  name: "AppointmentByRap",
  components: { DateRangePicker },
  data() {
    return {
      btnLoader: false,
      loading: false,
      sourceSummaryReport: null,
      sourceSummaryReportObject: null,
      filters_: {
        duration: "month",
        customDate: {},
        id: 0,
        tm_id: 0,
        from: "",
        to: "",
        export: false,
      },
    };
  },
  mounted() {
    console.log("component mounted");
    this.getSourceSummaryReprot();
  },
  computed: {
    orderbysource: function () {
      return orderBy(this.sourceSummaryReport, "sold_leads", "desc");
    },
  },
  beforeUpdate() {
    if (this.sourceSummaryReportObject) {
      this.sourceSummaryReportObject.fnDestroy();
    }
  },
  methods: {
    exportSalesRapData(duration) {
      console.log(duration);
      this.filters_.export = true;
      this.btnLoader = true;
      let startDate = this.filters_.customDate.startDate;
      let endDate = this.filters_.customDate.endDate;
      this.filters_.from = moment(new Date(startDate)).format("YYYY-MM-DD");
      this.filters_.to = moment(new Date(endDate)).format("YYYY-MM-DD");
      this.filters_.duration = duration;
      axios
        .post(axios.defaults.baseURL + "sourcesummaryreport", this.filters_, {
          headers: {
            Authorization: "Bearer " + this.$storage.get("auth").token,
          },
          responseType: "arraybuffer",
        })
        .then((response) => {
          this.btnLoader = false;
          this.filters_.export = false;
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", "sourcesummary.csv");
          document.body.appendChild(fileLink);
          fileLink.click();
        });
    },
    getSourceSummaryReprot(duration = "month") {
      this.loading = true;
      let startDate = this.filters_.customDate.startDate;
      let endDate = this.filters_.customDate.endDate;
      this.filters_.from = moment(new Date(startDate)).format("YYYY-MM-DD");
      this.filters_.to = moment(new Date(endDate)).format("YYYY-MM-DD");
      this.filters_.duration = duration;
      axios
        .post(axios.defaults.baseURL + "sourcesummaryreport", this.filters_, {
          headers: {
            Authorization: "Bearer " + this.$storage.get("auth").token,
          },
        })
        .then((response) => {
          this.loading = false;
          if ($.fn.DataTable.isDataTable("#sourceSummaryReport")) {
            $("#sourceSummaryReport").DataTable().destroy();
          }
          this.sourceSummaryReport = response.data;
          setTimeout(() => {
            if ($.fn.DataTable.isDataTable("#sourceSummaryReport")) {
              $("#sourceSummaryReport").DataTable().draw();
            } else {
              $("#sourceSummaryReport").DataTable({
                responsive: true,
                paging: false,
                bFilter: false,
                ordering: false,
                bInfo: false,
              });
            }
          });
        });
    },
  },
};
</script>
<style scoped>
.timeline {
  margin: 0px !important;
}
.datepicker-timeline {
  overflow: visible;
  margin-right: 5px !important;
}
.calender {
  position: relative;
}
.calender .vue-daterange-picker {
  position: absolute;
}
.calender .daterangepicker.opensleft {
  right: -100px;
}
.td {
  position: relative;
  right: -7px;
}
</style>
